import React from 'react';
import { Table } from 'react-bootstrap';
import './AppTable.scss';

const AppTable = ({ id, children, responsive = true, className = '' }) => {
  return (
    <div className={`rounded-lg mt-2 border ${responsive ? 'table-responsive' : ''}`}>
      <Table id={id} hover className={`smallFont m-0 ${className}`}>
        {children}
      </Table>
    </div>
  );
};

export default AppTable;
